/** TODO:: after Re-build all themes with the latest version of maintenance, remove these styles */
.s-maintenance-alert{
  &-wrapper{
    display: flex;
    min-height: 40px;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    --tw-bg-opacity: 1;
    background-color: rgba(26, 38, 61, var(--tw-bg-opacity));
    padding: 0.25rem 0.5rem;
    --tw-text-opacity: 1;
    color: rgba(255, 255, 255, var(--tw-text-opacity));
    a {
      transition: 0.35s cubic-bezier(0.2, 1, 0.3, 1)
    }
    * {
      color: inherit
    }
    @media (min-width: 640px) {
      padding-left:2rem;
      padding-right: 2rem
    }
  }
  &-content{
    margin-top: 1rem;
    margin-bottom: 1rem;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    @media (min-width: 640px) {
      padding-left:2rem;
      padding-right: 2rem
    }
  }
  &-container{
    display: flex;
    align-items: center
  }
  &-icon{
    margin-right: 1.25rem;
    display: none;
    @media (min-width: 640px) {
      display:block
    }
  }
  &-text{
    h2{
      margin-bottom: 0.5rem;
      font-size: 0.875rem;
      font-weight: 700;
      line-height: 1.4;
      @media (min-width: 640px) {
        font-size:1.5rem;
        line-height: 2rem
      }
    }
    p{
      margin: 0px;
      text-align: right;
      font-size: 10px;
      line-height: 1.2;
      @media (min-width: 640px) {
        text-align:center;
        font-size: 0.75rem;
        line-height: 1
      }
    }
  }
  &-btn{
    position: relative;
    margin-left: 4px;
    margin-right: 4px;
    display: inline-block;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    white-space: nowrap;
    border-radius: 0.125rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgba(93, 213, 196, var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: rgba(93, 213, 196, var(--tw-bg-opacity));
    padding: 0.5rem;
    text-align: center;
    vertical-align: middle;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.4;
    --tw-text-opacity: 1;
    color: rgba(255, 255, 255, var(--tw-text-opacity));
    &:hover {
      --tw-bg-opacity: 1;
      background-color: rgba(53, 203, 181, var(--tw-bg-opacity))
    }
    * {
      pointer-events: none
    }
    [dir="rtl"] &{
      margin-left: 1.25rem;
      margin-right: 0;
    }
    @media (min-width: 640px) {
      padding: 0.5rem 1rem;
    }
  }
}
